module.exports = __webpack_public_path__ + "static/media/Wanda_Portrait.8c8265f4.png";